import React from 'react';
import Card from './Card';
import { CardItem } from './Card';
import styles from './RelatedItemsSection.module.css';

interface RelatedItemsSectionProps {
  title: string;
  items: CardItem[];
  imageHeight?: string;
  className?: string;
  trackingEvent?: string;
}

const RelatedItemsSection: React.FC<RelatedItemsSectionProps> = ({
  title,
  items,
  imageHeight = 'h-48',
  className = '',
  trackingEvent,
}) => {
  return (
    <div className={`container mx-auto px-4 py-8 ${className}`}>
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-bold text-neutral mb-6">{title}</h2>

        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 ${styles.itemsGrid}`}
        >
          {items.map(item => (
            <Card
              key={item.id}
              item={item}
              imageHeight={imageHeight}
              trackingEvent={trackingEvent}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default RelatedItemsSection;
